import { useEffect } from "react";
import { BookCheck, ListChecks, MapPinHouse, Route } from "lucide-react";

import { type Conversation } from "shared/apiClient";
import { interpolate } from "shared/lib";

import { useIsApplicationRequirementsEnabled } from "shared/hooks";

import { TabItem } from "@/components/TabItem";

export const AnalysisTabItems = {
  PERMIT_REQUIREMENTS: "PERMIT_REQUIREMENTS",
  APPLICATION_REQUIREMENTS: "APPLICATION_REQUIREMENTS",
  LOT_AND_PROPOSAL: "LOT_AND_PROPOSAL",
  NEXT_STEPS: "NEXT_STEPS",
} as const;
export type AnalysisTabItems =
  (typeof AnalysisTabItems)[keyof typeof AnalysisTabItems];

export interface AnalysisTabProps {
  activeTab: AnalysisTabItems;
  conversation: Conversation | undefined | null;
  onChange?: (tab: AnalysisTabItems) => void;
  onSelect: (tab: AnalysisTabItems) => void;
}

export function AnalysisTabs({
  activeTab,
  conversation,
  onChange,
  onSelect,
}: AnalysisTabProps) {
  useEffect(() => {
    onChange?.(activeTab);
  }, [activeTab, onChange]);

  let isApplicationRequirementsEnabled = useIsApplicationRequirementsEnabled(
    conversation,
    "enquiry",
  );

  return (
    <div className="bg-interfaceBgDarkPaper flex w-full min-w-[320px] flex-row justify-center">
      <TabItem
        className="text-bodyxs"
        icon={ListChecks}
        label={interpolate("Permit {{br}} requirements", { br: <br /> })}
        selected={activeTab === AnalysisTabItems.PERMIT_REQUIREMENTS}
        onSelect={() => onSelect(AnalysisTabItems.PERMIT_REQUIREMENTS)}
      />
      {isApplicationRequirementsEnabled ? (
        <TabItem
          className="text-bodyxs"
          icon={BookCheck}
          label={interpolate("Application {{br}} requirements", { br: <br /> })}
          selected={activeTab === AnalysisTabItems.APPLICATION_REQUIREMENTS}
          onSelect={() => onSelect(AnalysisTabItems.APPLICATION_REQUIREMENTS)}
        />
      ) : null}
      <TabItem
        className="text-bodyxs"
        icon={MapPinHouse}
        label={interpolate("Lot and {{br}} proposal", { br: <br /> })}
        selected={activeTab === AnalysisTabItems.LOT_AND_PROPOSAL}
        onSelect={() => onSelect(AnalysisTabItems.LOT_AND_PROPOSAL)}
      />
      <TabItem
        className="text-bodyxs"
        icon={Route}
        label={interpolate("Next {{br}} steps", { br: <br /> })}
        selected={activeTab === AnalysisTabItems.NEXT_STEPS}
        onSelect={() => onSelect(AnalysisTabItems.NEXT_STEPS)}
      />
    </div>
  );
}
